module.exports = __webpack_public_path__ + "img/world-energy-trends-cover.218ac21.jpg";